//This file contains the code for filters objects for thw recipes
//section of the website and the methods to act upon them.  Note
//thet each page will have its owm filter and the recipe index and
//recipe edit pages will make use of different filtering fields.

//The filters object.
const filters = {
    searchText: '',
    sortBy: 'byEdited', // or 'byCreated' or 'alphabetical'
    hideOnHand: false
};

//Function to get filters.
export const getFilters = () => filters;

//Function to update filters. The only parameter is an object 
//that can have the fields hideOnHand. searchText, and sortBy. If 
//present, they indicate that that note field is to be updated.
//Note: No one page uses all of the fields.
export const updateFilters = (updates) => {
    //Update search text if given.
    if (typeof updates.searchText === 'string') {
        filters.searchText = updates.searchText;
    }

    //Update sort method if given.
    if (typeof updates.sortBy === 'string') {
        filters.sortBy = updates.sortBy;
    }

    //Update boolean the hides on-hind ingredients if given.
    if (typeof updates.hideOnHand === 'boolean') {
        filters.hideOnHand = updates.hideOnHand;
    }
}